import initialStates from '../storeInitialState';
import {
  APP_STATE_LOADED_SUCCESSFULLY,
  CVV_MODAL_TRIGGER,
  EXPIRY_DATE_MODAL_TRIGGER,
  TRANSACTION_FAILED_MODAL_TRIGGER,
} from '../actions/types';

const appState = (state = initialStates.appState, action) => {
  switch (action.type) {
    case APP_STATE_LOADED_SUCCESSFULLY:
      return {
        ...state,
        ...action.payload.state,
      };

    case TRANSACTION_FAILED_MODAL_TRIGGER:
      return {
        ...state,
        failedTransactionModal: action.payload.flag,
        failedTransactionModalMessage: action.payload.message,
      };
    case CVV_MODAL_TRIGGER:
      return {
        ...state,
        cvvModalFlag: action.payload,
      };
    case EXPIRY_DATE_MODAL_TRIGGER:
      return {
        ...state,
        expiryDateModalFlag: action.payload,
      };
    default:
      return state;
  }
};
export default appState;
